<template>
<div>
  <el-dialog title="SSH 主机指纹确认" :visible.sync="visible" width="535px" :close-on-click-modal="false" @close="checkSent" @closed="focusCurTerm">
    <div class="info">
      <div class="info-line">主机名: {{arg.Hostname}}</div>
      <div class="info-line">主机地址: {{arg.Remote}}</div>
      <div class="info-line">公钥类型: {{arg.PublicKeyType}}</div>
      <div class="info-line">公钥: {{arg.PublicKey}}</div>
      <div class="info-line">MD5 指纹: {{arg.FingerprintLegacyMD5}}</div>
      <div class="info-line">SHA256 指纹: {{arg.FingerprintSHA256}}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="sendReject">拒绝</el-button>
      <el-button size="mini" @click="sendTrustOnce">信任一次</el-button>
      <el-button size="mini" @click="sendTrustAlways" type="primary" :id="`s-v-s-k-${tabID}`">总是信任</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import model from "../../../model"
export default {
  name: "sshVerifyServerKeys",
  props: ["tabID", "session"],
  data() {
    return {
      visible: false,
      ctrlMsg: undefined,
      arg: new model.SshVerifyHostKeyData(),
      sentAnswer: false,
    }
  },
  methods: {
    show(cmdMsg) {
      this.visible = true
      console.log("cmdMsg:", cmdMsg)
      this.ctrlMsg = cmdMsg
      this.arg = model.SshVerifyHostKeyData.NewFromJson(cmdMsg.Cmd.Arg)
      this.focusAlways()
    },
    hide() {
      this.visible = false
    },
    focusAlways() {
      this.utils.domFocusById(`s-v-s-k-${this.tabID}`)
    },
    focusCurTerm() {
      this.env.pub('focusTerm-' + this.tabID)
    },
    checkSent() {
      if (this.sentAnswer === false) {
        this.sendReject()
      }
    },
    sendReject() {
      this.sendAnswer("reject")
    },
    sendTrustOnce() {
      this.sendAnswer("once")
    },
    sendTrustAlways() {
      this.sendAnswer("always")
    },
    sendAnswer(answer) {
      this.session.SendCtrlRet(answer, undefined, this.ctrlMsg)
      this.sentAnswer = true
      this.hide()
    },
  },
}
</script>

<style scoped>
.info {
  text-align: left;
}
.info-line {
  padding: 0.4em 0.5em;
}
</style>
